import { engineComponent, NumberUtils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../../Utils/FrameTimer";
import { ComponentTypes } from "../../../Components/ComponentTypes";
import { UserControls } from "./UserControls";
import { GambleActions } from "../Actions/GambleActions";
import { HtmlController } from "../../../HTMLComponents/HtmlController";
import { GambleController } from "../../../GameComponents/Gamble/GambleController";
import { ModuleManager } from "../../../Managers/ModuleManager";
import { DataManager } from "../../../Managers/DataManager";
import { GameData } from "../Datas/GameData";
import { GameManager } from "../../../Managers/GameManager";
import { LimitDialog } from "../Dialogs/LimitDialog";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { AppContext } from "../../../../Common/AppContext";
import { BetManager } from "../../../Managers/BetManager";
import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";
import { ReplayService, ReplayController } from "../../../Replay";

var GameModules = Communication.Game.GameModules;
var Color = Communication.Game.Color;

@engineComponent(ComponentTypes.HtmlElement)
export class GambleUserControls extends UserControls {
    protected _controller: GambleController;

    private _collectDelay: FrameTimerEventEmitter;

    private _gambleTickerDefault: HTMLElement;
    private _gambleTickerHalveLimit: HTMLElement;
    private _gambleTickerSoftLimit: HTMLElement;
    private _gambleTickerGameLimit: HTMLElement;

    private _collectedWinValue: number = 0;
    private _allowStart: boolean;

    private _screen: HTMLElement;

    constructor() {
        super("gamble");

        this._collectDelay = CreateFrameTimer("collectDelay");
        this._collectDelay.on(FrameTimerEvents.Complete, this.outro.bind(this));

        this._allowStart = true;
    }

    private ticker(state: string = ""): void {
        if (this._gambleTickerDefault != null) {
            this._gambleTickerDefault.style.display = "none";
        }
        if (this._gambleTickerHalveLimit != null) {
            this._gambleTickerHalveLimit.style.display = "none";
        }
        if (this._gambleTickerSoftLimit != null) {
            this._gambleTickerSoftLimit.style.display = "none";
        }
        if (this._gambleTickerGameLimit != null) {
            this._gambleTickerGameLimit.style.display = "none";
        }

        switch (state) {
            case "default":
                if (this._gambleTickerDefault != null) {
                    this._gambleTickerDefault.style.display = "block";
                }
                break;
            case "halvelimit":
                if (this._gambleTickerHalveLimit != null) {
                    this._gambleTickerHalveLimit.style.display = "block";
                }
                break;
            case "softLimit":
                if (this._gambleTickerSoftLimit != null) {
                    this._gambleTickerSoftLimit.style.display = "block";
                }
                break;
            case "limit":
                if (this._gambleTickerGameLimit != null) {
                    this._gambleTickerGameLimit.style.display = "block";
                }
                break;
        }
    }

    create(node: Element): void {
        super.create(node);

        this.registerActions();

        this._gambleTickerDefault = document.getElementById("gambleTickerDefault");
        this._gambleTickerHalveLimit = document.getElementById("gambleTickerHalveLimit");
        this._gambleTickerSoftLimit = document.getElementById("gambleTickerSoftLimit");
        this._gambleTickerGameLimit = document.getElementById("gambleTickerGameLimit");
        this._screen = document.getElementById("screen");
        this.ticker("default");
    }

    addController(controller: GambleController): void {
        this._controller = controller;
        this._controller.on(GambleController.StartReceived, this.startReceived.bind(this));
        this._controller.on(GambleController.SelectReceived, this.selectReceived.bind(this));
        this._controller.on(GambleController.HalveReceived, this.halveReceived.bind(this));
        this._controller.on(GambleController.WinCalculationFinished, this.winCalculationFinished.bind(this));
        this._controller.on(GambleController.AllWinsFinished, this.allWinsFinished.bind(this));
        this._controller.on(GambleController.Lose, this.lose.bind(this));
        this._controller.on(GambleController.IntroFinished, this.introFinished.bind(this));
        this._controller.on(GambleController.OutroFinished, this.outroFinished.bind(this));
    }

    registerActions(): void {
        this.actions.registerActions({
            [GambleActions.ActionGambleStart]: false,
            [GambleActions.ActionGambleRed]: false,
            [GambleActions.ActionGambleBlack]: false,
            [GambleActions.ActionGambleHalve]: false,
            [GambleActions.ActionGambleCollect]: false,
        });
    }

    initReceived(): void {
        super.initReceived();

        this._controller.initReceived();
    }

    collectReceived(): void {
        this.ticker("");
        DataManager.updateDataElement(GameData.DataGambleAttempts, 0 + "");

        super.collectReceived();

        DataManager.updateGameDataFromModule(GameData.DataGambleColorWin, "");
        DataManager.updateGameDataFromModule(GameData.DataGambleCurrentWin, "");
        DataManager.updateGameDataFromModule(GameData.DataGambleColorWinDenom, "");
        DataManager.updateGameDataFromModule(GameData.DataGambleCurrentWinDenom, "");
        DataManager.updateDataElements();

        Platforms.Platforms.roundEnded({
            id: GameManager.gameResponse.roundId,
            win: this._collectedWinValue,
            balanceAfter: parseFloat(DataManager.getDataById(GameData.DataBalanceTotal)),
        });
        Platforms.Platforms.balanceUpdated({ amount: GameManager.gameResponse.balance.real });
        this._collectDelay.start(30);

        if (AppContext != null && AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
            DataManager.updateDataElement(GameData.DataTotalWin, this._collectedWinValue.toString());
        }
        this.changeWinBox(true);
    }

    restoreGameRound(): void {
        this.prepareNewGameRound();
    }

    startReceived(): void {
        if (
            GameManager.gambleResponse != null &&
            GameManager.gambleResponse["totalCount"] != null &&
            GameManager.gambleResponse["currentCount"] != null
        ) {
            DataManager.updateDataElement(
                GameData.DataGambleAttempts,
                (GameManager.gambleResponse["totalCount"] - GameManager.gambleResponse["currentCount"]).toString(),
            );
        }
        ModuleManager.startGamble();
    }

    selectReceived(): void {
        if (GameManager.gambleResponse["paidWin"] != null) {
            this._collectedWinValue = parseFloat(
                NumberUtils.add(GameManager.gambleResponse.currentWin, GameManager.gambleResponse["paidWin"]),
            );
        } else {
            this._collectedWinValue = GameManager.gambleResponse.currentWin;
        }
    }

    halveReceived(): void {
        DataManager.updateGameDataFromModule(
            GameData.DataGambleColorWin,
            GameManager.gambleResponse.colorWin.toString(),
        );
        DataManager.updateGameDataFromModule(
            GameData.DataGambleCurrentWin,
            GameManager.gambleResponse.currentWin.toString(),
        );
        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataGambleColorWinDenom,
                parseInt(
                    NumberUtils.devide(GameManager.gambleResponse.colorWin, BetManager.CoinSize).toString(),
                ).toString(),
            );
            DataManager.updateGameDataFromModule(
                GameData.DataGambleCurrentWinDenom,
                parseInt(
                    NumberUtils.devide(GameManager.gambleResponse.currentWin, BetManager.CoinSize).toString(),
                ).toString(),
            );
        }
        DataManager.updateDataElements();

        Platforms.Platforms.balanceUpdated({ amount: GameManager.gameResponse.balance.real });

        this.prepareNewGameRound();
    }

    dispatchAction(action: string): void {
        super.dispatchAction(action);

        if (this.actions.getActionState(action)) {
            PlayList.play("SND_Click");
            super.dispatchAction(action);

            switch (action) {
                case GambleActions.ActionGambleStart:
                    this.start();
                    break;
                case GambleActions.ActionGambleHalve:
                    this.halve();
                    break;
                case GambleActions.ActionGambleBlack:
                    this.select(Color.Black);
                    break;
                case GambleActions.ActionGambleRed:
                    this.select(Color.Red);
                    break;
                case GambleActions.ActionGambleCollect:
                    this.collect();
                    break;
            }
        }
    }

    collect(): void {
        if (GameManager.gameResponse != null && GameManager.gameResponse.totalWin > 0) {
            Platforms.Platforms.win(GameManager.gameResponse.totalWin);
        }

        if (GameManager.gambleResponse["paidWin"] != null) {
            this._collectedWinValue = parseFloat(
                NumberUtils.add(GameManager.gambleResponse.currentWin, GameManager.gambleResponse["paidWin"]),
            );
        } else {
            this._collectedWinValue = GameManager.gambleResponse.currentWin;
        }

        if (GameManager.gameResponse.totalWin > 0) {
            DataManager.updateLossLimit(GameManager.gameResponse.totalWin);
        }
        super.collect();

        this.disable();
        this.playCollectSound();

        LimitDialog.closeDialog();

        GameManager.collect(GameModules.Gamble);
    }

    start(): void {
        this._allowStart = false;
        this._collectedWinValue = GameManager.gameResponse.totalWin;
        ModuleManager.disableBase();
        this.disable();
        DataManager.updateGameDataFromModule(
            GameData.DataGambleColorWin,
            GameManager.gambleResponse.colorWin.toString(),
        );
        DataManager.updateGameDataFromModule(
            GameData.DataGambleCurrentWin,
            GameManager.gambleResponse.currentWin.toString(),
        );
        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataGambleColorWinDenom,
                parseInt(
                    NumberUtils.devide(GameManager.gambleResponse.colorWin, BetManager.CoinSize).toString(),
                ).toString(),
            );
            DataManager.updateGameDataFromModule(
                GameData.DataGambleCurrentWinDenom,
                parseInt(
                    NumberUtils.devide(GameManager.gambleResponse.currentWin, BetManager.CoinSize).toString(),
                ).toString(),
            );
        }
        DataManager.updateDataElements();
        this._controller.start();
    }

    select(color: Communication.Game.Color): void {
        this.ticker("");
        this.disable();
        this._controller.select(color);
    }

    halve(): void {
        if (GameManager.gambleResponse.currentWin > 0) {
            DataManager.updateLossLimit(GameManager.gambleResponse.currentWin / 2);
        }
        this.disable();
        this.playCollectSound();
        this._controller.halve();
    }

    winCalculationFinished(): void {
        if (GameManager.gambleResponse.currentWin > 0) {
            DataManager.updateGameDataFromModule(
                GameData.DataGambleCurrentWin,
                GameManager.gambleResponse.currentWin.toString(),
            );
            if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
                DataManager.updateGameDataFromModule(
                    GameData.DataGambleCurrentWinDenom,
                    parseInt(
                        NumberUtils.devide(GameManager.gambleResponse.currentWin, BetManager.CoinSize).toString(),
                    ).toString(),
                );
            }
            DataManager.updateDataElements();
        } else {
            if (
                GameManager.gambleResponse != null &&
                GameManager.gambleResponse["totalCount"] != null &&
                GameManager.gambleResponse["currentCount"] != null
            ) {
                DataManager.updateDataElement(GameData.DataGambleAttempts, 0 + "");
            }
            DataManager.updateGameDataFromModule(GameData.DataGambleColorWin, "");
            DataManager.updateGameDataFromModule(GameData.DataGambleCurrentWin, "");
            DataManager.updateGameDataFromModule(GameData.DataGambleColorWinDenom, "");
            DataManager.updateGameDataFromModule(GameData.DataGambleCurrentWinDenom, "");
            DataManager.updateDataElements();
        }
    }

    allWinsFinished(): void {
        DataManager.updateGameDataFromModule(
            GameData.DataGambleColorWin,
            GameManager.gambleResponse.colorWin.toString(),
        );
        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataGambleColorWinDenom,
                parseInt(
                    NumberUtils.devide(GameManager.gambleResponse.colorWin, BetManager.CoinSize).toString(),
                ).toString(),
            );
        }
        DataManager.updateDataElements();
        if (GameManager.gambleResponse.currentWin > 0) {
            this.prepareNewGameRound();
        }
    }

    lose(): void {
        this.outro();

        if (this._collectedWinValue > 0) {
            if (AppContext != null && AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
                DataManager.updateDataElement(GameData.DataTotalWin, this._collectedWinValue.toString());
            }
            this.changeWinBox(true);
        } else {
            this.changeWinBox();
        }

        Platforms.Platforms.roundEnded({
            id: GameManager.gameResponse.roundId,
            win: this._collectedWinValue,
            balanceAfter: parseFloat(DataManager.getDataById(GameData.DataBalanceTotal)),
        });
        Platforms.Platforms.balanceUpdated({ amount: GameManager.gameResponse.balance.real });
    }

    initIntro(): void {
        super.initIntro();

        FreeRoundBonus.disableUi();

        this.prepareNewGameRound();

        if (this._screen != null && !this._screen.classList.contains("_inGamble")) {
            this._screen.classList.add("_inGamble");
        }

        DataManager.updateGameDataFromModule(
            GameData.DataGambleColorWin,
            GameManager.gambleResponse.colorWin.toString(),
        );
        DataManager.updateGameDataFromModule(
            GameData.DataGambleCurrentWin,
            GameManager.gambleResponse.currentWin.toString(),
        );
        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataGambleColorWinDenom,
                parseInt(
                    NumberUtils.devide(GameManager.gambleResponse.colorWin, BetManager.CoinSize).toString(),
                ).toString(),
            );
            DataManager.updateGameDataFromModule(
                GameData.DataGambleCurrentWinDenom,
                parseInt(
                    NumberUtils.devide(GameManager.gambleResponse.currentWin, BetManager.CoinSize).toString(),
                ).toString(),
            );
        }
        DataManager.updateDataElements();

        this._controller.initIntro();
    }

    intro(): void {
        FreeRoundBonus.disableUi();
        if (this._screen != null && !this._screen.classList.contains("_inGamble")) {
            this._screen.classList.add("_inGamble");
        }
        this._controller.intro();
    }

    introFinished(): void {
        this.prepareNewGameRound();
    }

    outro(): void {
        if (this._screen != null && this._screen.classList.contains("_inGamble")) {
            this._screen.classList.remove("_inGamble");
        }
        DataManager.Collectable = true;
        this._collectDelay.stop();
        this._controller.outro();
    }

    outroFinished(): void {
        this._allowStart = true;
        FreeRoundBonus.enableUi();
        ModuleManager.introModule(GameModules.Base);
    }

    prepareNewGameRound(): void {
        if (
            GameManager.gambleResponse != null &&
            GameManager.gambleResponse["totalCount"] != null &&
            GameManager.gambleResponse["currentCount"] != null
        ) {
            DataManager.updateDataElement(
                GameData.DataGambleAttempts,
                (GameManager.gambleResponse["totalCount"] - GameManager.gambleResponse["currentCount"]).toString(),
            );
            DataManager.updateGameDataFromModule(
                GameData.DataGambleAttempts,
                (GameManager.gambleResponse["totalCount"] - GameManager.gambleResponse["currentCount"]).toString(),
            );
        }

        if (DataManager.GameLimit) {
            DataManager.updateDataElement(GameData.DataGambleAttempts, 0 + "");
            DataManager.updateGameDataFromModule(GameData.DataGambleAttempts, 0 + "");

            this.limit();
            this.ticker("limit");
        } else {
            let softLimit: boolean = false;
            if (GameManager.gambleResponse.colorWin === 0) {
                softLimit = true;
            }

            if (softLimit) {
                if (GameManager.gambleResponse.halveEnabled) {
                    this.ticker("softLimit");
                } else {
                    this.ticker("limit");
                }
            } else if (GameManager.gambleResponse != null && !GameManager.gambleResponse.halveEnabled) {
                this.ticker("halveLimit");
            } else {
                this.ticker("default");
            }

            this.actions.changeActionStates({
                [GambleActions.ActionGambleStart]: false,
                [GambleActions.ActionGambleRed]: !softLimit,
                [GambleActions.ActionGambleBlack]: !softLimit,
                [GambleActions.ActionGambleHalve]: GameManager.gambleResponse.halveEnabled,
                [GambleActions.ActionGambleCollect]: true,
            });
        }

        HtmlController.updateActionElements(this.getAllActions());

        if (ReplayService.instance.isReplayMode) {
            ReplayController.instance.notifyReady();
        }
    }

    limit(): void {
        LimitDialog.openDialog();

        this.actions.changeActionStates({
            [GambleActions.ActionGambleStart]: false,
            [GambleActions.ActionGambleRed]: false,
            [GambleActions.ActionGambleBlack]: false,
            [GambleActions.ActionGambleHalve]: false,
            [GambleActions.ActionGambleCollect]: true,
        });
    }

    enable(): void {
        this.actions.changeActionState(GambleActions.ActionGambleStart, this._allowStart);
        HtmlController.updateActionElements(this.getAllActions());
    }

    disable(): void {
        this._actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/UserControls/GambleUserControls.ts
 **/